import {
  GraphQLLayoutService,
  RestLayoutService,
  constants,
} from '@sitecore-jss/sitecore-jss-react';
import config from '../temp/config';

export class LayoutServiceFactory {

  create(sitename) {
    const layoutConfiguration = {
      apiKey: config.sitecoreApiKey,
      siteName: sitename ?? config.sitecoreSiteName,
      configurationName: 'sxa-jss'
    }

    //This needs to retrieve the correct market planner data on current website. Otherwise, it will ignore auth cookies.
    if (config.environmentName === 'local') {
      layoutConfiguration.apiHost = config.sitecoreApiHost;
    }

    return process.env.REACT_APP_FETCH_WITH === constants.FETCH_WITH.GRAPHQL
      ? new GraphQLLayoutService({ layoutConfiguration })
      : new RestLayoutService(layoutConfiguration);
  }
}

export const layoutServiceFactory = new LayoutServiceFactory();
